import React from 'react';
import { useTheme } from '../../context/theme-context';
import styled from 'styled-components';

interface ToggleButtonProps {
  $isDark: boolean;
}

const ToggleButton = styled.button<ToggleButtonProps>`
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1000;
  padding: 0.75rem;
  border-radius: 9999px;
  transition: all 0.3s ease;
  background: ${props => props.$isDark 
    ? 'rgba(212, 178, 84, 0.15)' 
    : 'rgba(212, 178, 84, 0.2)'};
  border: 2px solid ${props => props.$isDark 
    ? 'rgba(212, 178, 84, 0.3)' 
    : 'rgba(212, 178, 84, 0.4)'};
  backdrop-filter: blur(10px);
  min-width: 48px;
  min-height: 48px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 24px;
    height: 24px;
    color: ${props => props.$isDark ? '#D4B254' : '#B89741'};
    transition: transform 0.3s ease;
  }
`;

export const ThemeToggle: React.FC = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <ToggleButton
      onClick={toggleTheme}
      $isDark={isDark}
      title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      aria-label={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      {isDark ? (
        <svg 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" 
          />
        </svg>
      ) : (
        <svg 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" 
          />
        </svg>
      )}
    </ToggleButton>
  );
};
